import React from "react";
import { motion } from "framer-motion";
import diamond from "./../../../assets/aUV_diamond.svg";

function AboutUsValores() {
  const valores = [
    {
      title: "Generadores de conexiones",
      description:
        "La cooperación empática, comunicación activa y centralización en el cliente son fundamentales para generar conexiones. Al igual que la madurez emocional y generosidad social son importantes para mantener esas conexiones de forma positiva.",
    },
    {
      title: "Valentía transformadora",
      description:
        "Nuestro espíritu transformador, honor y evolución constante son valores claves para el éxito empresarial. Con estos valores como guía, podemos lograr cualquier objetivo y superar cualquier obstáculo en el camino.",
    },
    {
      title: "Jugar con propósito",
      description:
        "En nuestra empresa, sabemos que la atención al detalle, productividad y la conexión con nuestros clientes son fundamentales para alcanzar el éxito. Por eso, nos esforzamos por mantener una energía contagiosa que nos permite trabajar con propósito, manteniendo siempre la motivación y el entusiasmo.",
    },
    {
      title: "Exploradores de pensamiento",
      description:
        "La apertura al aprendizaje y la diversidad, junto con el conocimiento sistemático y la curiosidad permanente, son la clave para la innovación pragmática y una visión holística. Juntos, estos valores fomentan una cultura de aprendizaje y mejora continua que puede marcar la diferencia en cualquier organización.",
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.6,
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  return (
    <div className="w-full h-screen bg-black flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8 overflow-y-auto">
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="w-full max-w-6xl py-16 px-4"
      >
        {/* Header Section */}
        <motion.div
          initial={{ opacity: 0, y: 100, scale: 0.8 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.5, ease: "backOut" }}
          className="flex flex-col items-center justify-center gap-6 mb-8"
        >
          <motion.img
            initial={{ opacity: 0, scale: 0, rotate: -180 }}
            animate={{ opacity: 1, scale: 1, rotate: 0 }}
            transition={{
              duration: 1.2,
              ease: "backOut",
              type: "spring",
              bounce: 0.6,
            }}
            whileHover={{
              rotate: 360,
              scale: 1.2,
              transition: { duration: 0.6, ease: "backOut" },
            }}
            src={diamond}
            className="w-12 h-12 cursor-pointer"
            alt="Diamond icon"
          />
          <motion.h1
            initial={{ opacity: 0, letterSpacing: "2rem" }}
            animate={{ opacity: 1, letterSpacing: "0.1rem" }}
            transition={{ duration: 1.2, delay: 0.8 }}
            className="text-white text-3xl sm:text-2xl lg:text-3xl font-bold font-montserrat text-center"
          >
            Valores
          </motion.h1>
        </motion.div>

        {/* Values Grid */}
        {valores.map((valor, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 80, rotateX: -90, scale: 0.8 }}
            animate={{ opacity: 1, y: 0, rotateX: 0, scale: 1 }}
            transition={{ duration: 0.8, ease: [0.25, 0.46, 0.45, 0.94] }}
            className="text-left space-y-4 p-6 -m-6 rounded-2xl border border-transparent"
          >
            <motion.h4
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.6 + index * 0.1 }}
              className="text-white text-base sm:text-lg lg:text-xl font-semibold font-montserrat relative"
            >
              {valor.title}
            </motion.h4>
            <motion.p
              initial={{ opacity: 0, filter: "blur(5px)" }}
              animate={{ opacity: 1, filter: "blur(0px)" }}
              transition={{ duration: 0.8, delay: 0.8 + index * 0.1 }}
              className="text-white text-sm lg:text-base font-normal font-montserrat leading-relaxed"
            >
              {valor.description}
            </motion.p>
          </motion.div>
        ))}

        {/* Decorative elements */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.03 }}
          transition={{ duration: 3, delay: 2 }}
          className="absolute inset-0 pointer-events-none overflow-hidden"
        >
          {[...Array(25)].map((_, i) => (
            <motion.div
              key={i}
              initial={{
                opacity: 0,
                x: Math.random() * window.innerWidth,
                y: Math.random() * window.innerHeight,
                rotate: 0,
              }}
              animate={{
                opacity: [0, 0.1, 0],
                rotate: [0, 360, 720],
                scale: [0.5, 1, 0.5],
                x: [
                  Math.random() * window.innerWidth,
                  Math.random() * window.innerWidth,
                  Math.random() * window.innerWidth,
                ],
                y: [
                  Math.random() * window.innerHeight,
                  Math.random() * window.innerHeight - 200,
                  Math.random() * window.innerHeight,
                ],
              }}
              transition={{
                duration: Math.random() * 6 + 4,
                delay: Math.random() * 4 + 2,
                repeat: Infinity,
                repeatDelay: Math.random() * 3 + 1,
              }}
              className="absolute w-1 h-1 bg-white rounded-full"
              style={{
                clipPath: "polygon(50% 0%, 0% 100%, 100% 100%)",
              }}
            />
          ))}
        </motion.div>
      </motion.div>
    </div>
  );
}

export default AboutUsValores;
